/**
 * 任务信息维护
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>任务信息维护</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="任务名称 :">
        <el-input size="small" v-model="formInline.positionName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="任务类型 :">
        <el-input size="small" v-model="formInline.positionTypeName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="合规进度 :">
        <el-select size="small" v-model="formInline.complianceProgress" placeholder="请选择">
          <el-option v-for="val,index in status_list" :label="val.label" :value="val.value" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary"  @click="search">搜索</el-button>
        <el-button size="small"  @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px;">
      <el-button size="small" type="primary">发布任务</el-button>
      <el-button size="small">导出数据</el-button>
    </div>

    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column fixed prop="positionId" label="任务ID" width="200">
      </el-table-column>
      <el-table-column prop="positionName" label="任务名称" width="200">
      </el-table-column>
      <el-table-column prop="positionTypeName" label="任务类型" width="200">
        <template slot-scope="scope">
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
          <div>{{scope.row.positionTypeName}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="positionName" label="合规材料补充" width="200">
        <template slot-scope="scope">
            <div  v-if="!scope.row.complianceMaterialsUrl" class="btnNoBorderBlue" @click="uploadFile(scope.row)">上传</div>
            <!-- 下载？？ -->
          </template>
      </el-table-column>
      <el-table-column label="合规进度" width="200">
        <template slot-scope="scope">
            <span>{{scope.row.complianceProgressDesc}}</span>
          </template>
      </el-table-column>
      <el-table-column label="整改意见" width="300">
        <template slot-scope="scope">
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
          <div>{{scope.row.rectificationOpinions}}</div>
        </template>
      </el-table-column>
      <el-table-column
          label="相关附件"
        >
        <template slot-scope="scope">
          <!-- <exportBtn v-if="scope.row.rectificationAppendixUrl" :exportUrl="exportUrlPdf" className="btnNoBorderBlue" text="查看" :exportParam="{open:1, key:scope.row.rectificationAppendixUrl}"></exportBtn>  -->
        </template>
        </el-table-column>  
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="部门名称" prop="deptName">
          <el-input size="small" v-model="editForm.deptName" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input size="small" v-model="editForm.deptNo" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      status_list: [{
        label: '上线',
        value: 10
      },{
        label: '下线',
        value: 20
      }],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        date: [],
        positionId: '',
        positionName: '',
        positionState: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {

      },
      formInline: {
        page: 1,
        pageSize: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      }
    this.getdata(this.formInline)
    },
    uploadFile(){

    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        totalCount: 5,
        data: [
        {
                "positionId": "P1189584229093089280",
                "cooperatorId": null,
                "cooperatorName": null,
                "positionName": "2023-12-27推广服务",
                "upperAmount": 9499900.0,
                "monthAmount": 100.0,
                "unit": "月",
                "positionDesc": "",
                "positionState": 10,
                "positionStateDesc": "上架",
                "recruitmentState": 10,
                "recruitmentStateDesc": "上线",
                "makePeriod": "2023-12-27至2024-12-26",
                "settlementCycle": 3,
                "createTime": "2023-12-27 15:03:02",
                "hireTime": null,
                "gender": 0,
                "genderDesc": "男女不限",
                "upperAge": 70,
                "monthAge": 18,
                "education": "学历不限",
                "workAddress": "不限-不限-不限",
                "positionTypeName": "推广服务",
                "qrUrl": null,
                "apiFlag": 0,
                "popoverFlag": 0,
                "salaryDesc": null,
                "weight": "7939",
                "gxcShareFlag": false,
                "positionWorkerContent": null,
                "positionWageStatement": null,
                "positionWorkTime": null,
                "positionOtherBenefits": null
            }
        ]
      }
      this.loading = false
      this.listData = res.data
      this.listData.map(item => {
        if(item.recruitmentStateDesc == '上线'){
          item.status = true
        }else{
          item.status = false
        }
      })
      this.pageparm.page = this.formInline.page
      this.pageparm.pageSize = this.formInline.pageSize 
      this.pageparm.total = res.data.totalCount
      // 模拟数据结束

    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page
      this.formInline.pageSize= parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // deptDelete(row.deptId)
          //   .then(res => {
          //     if (res.success) {
          //       this.$message({
          //         type: 'success',
          //         message: '公司已删除!'
          //       })
          //       this.getdata(this.formInline)
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.loading = false
          //     this.$message.error('公司删除失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item{
  margin-bottom: 10px!important;
}
.userRole {
  width: 100%;
}
.btnNoBorderBlue{
  cursor: pointer;
  color: #409EFF;
}
</style>

 


// WEBPACK FOOTER //
// src/views/ruleCenter/complianceCenter.vue